// eslint-disable-next-line @typescript-eslint/no-var-requires
const strftime = require("strftime");

/**
 * Render a date-only ISO string (e.g. "2026-09-15") using the account's
 * strftime short-date pattern. Parses the value as LOCAL time so a
 * date-only value never shifts a day backward in negative-UTC timezones.
 * Returns null when the input is empty or unparseable.
 */
export const formatAccountDate = (
  dateString: string,
  shortDateFormat?: string
): string | null => {
  if (!dateString) return null;

  const [year, month, day] = dateString.split("-").map(Number);
  if (!year || !month || !day) return null;

  const localDate = new Date(year, month - 1, day);
  if (Number.isNaN(localDate.getTime())) return null;

  return strftime(shortDateFormat || "%m/%d/%Y", localDate);
};
